<template>
  <div
    v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.DELETE)"
    :class="{'spl-modal-holder-show': isVisible}"
    class="spl-modal-holder spl-create-cmr-modal"
    @click.self="closeModal">
    <div class="spl-modal">
      <div class="spl-modal__label">
        Create Documents
      </div>

      <div class="spl-modal__close" @click="closeModal" />

      <h2 v-if="!isSameAddress" class="error">
        You can create documents only when the parcels have the same Delivery and Pickup Address
      </h2>
      <div v-if="isSameAddress" class="spl-create-cmr-modal__checkboxes">
        <form-checkbox v-model="createCMR">
          Create CMR
        </form-checkbox>

        <form-checkbox v-model="createDeliveryNote">
          Create Delivery Note
        </form-checkbox>

        <form-checkbox v-model="createLoadingList">
          Create Loading List
        </form-checkbox>
      </div>
      <div class="row">
        <div class="col6">
          <form-button
            :wide="true"
            :secondary="true"
            @onClick="closeModal">
            Cancel
          </form-button>
        </div>
        <div class="col6">
          <form-button
            :wide="true"
            :disabled="!isSameAddress || (!createCMR && !createDeliveryNote && !createLoadingList)"
            @onClick="submitModal">
            Create
          </form-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import webApi from '@/webApi'
import { CreateCMRModel } from '@/webApi/DataModels'
import constants from '@/constants'
import Helpers from '@/helpers.vue'
import { map } from 'lodash'

export default {
  mixins: [Helpers],
  props: ['parcels'],
  data () {
    return {
      isVisible: false,
      message: '',
      createCMR: false,
      createDeliveryNote: false,
      createLoadingList: false,
      isSameAddress: true,
      constants
    }
  },
  watch: {
    parcels: function (newValue) {
      if (newValue && newValue.length > 0) {
        this.isVisible = true
        if (newValue.length > 1) {
          this.isSameAddress = true
          var deliveryAddress = this.parcels[0].Delivery_Address_ID
          var pickupAddress = this.parcels[0].Pickup_Address_ID
          for (let i = 0; i < this.parcels.length; i++) {
            if (this.parcels[i].Delivery_Address_ID !== deliveryAddress || this.parcels[i].Pickup_Address_ID !== pickupAddress) {
              this.isSameAddress = false
            }
          }
        } else {
          this.isSameAddress = true
        }
      } else {
        this.isVisible = false
      }
    }
  },
  mounted () {
  },
  methods: {
    submitModal () {
      var createCMRModel:CreateCMRModel = {
        Parcel_IDs: map(this.parcels, 'Parcel_ID'),
        Create_CMR: this.createCMR,
        Create_Delivery_Note: this.createDeliveryNote,
        Create_Loading_List: this.createLoadingList
      } as CreateCMRModel

      webApi.document.create_CMR_Documents(createCMRModel).then((result) => {
        this.downloadFile(result, 'CMR.pdf')
        this.isVisible = false
        this.message = ''
        this.$toast('Documents successfully created', constants.defaultToastOptions())
        this.$emit('cmrCreated')
      }).catch((error) => {
        window.bus.$emit('openErrorModal', 'Error creating Documents: ' + error.body.ExceptionMessage)
      })
    },
    // Close the scan window
    closeModal () {
      this.isVisible = false
    }
  }
}
</script>

<style lang="scss">
  @import '../../variables.scss';
.spl-create-cmr-modal {
  .error {
    margin-bottom: 20px;
  }
  &__checkboxes {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
    & .spl-checkbox-group__item__label {
      margin: 6px;
    }
  }
}
</style>
